"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
function ParsedTemplate(props) {
  const {
    template
  } = props;
  const tokens = [];
  const pattern = /(?:\*{([^*{}]*)}\*)|(?:_{([^_{}]*)}_)|(?:{([^{}]*)})|(\n)/g;
  const matches = [...template.matchAll(pattern)];
  let lastIndex = 0;
  if (matches.length === 0) {
    return react_1.default.createElement("span", null, template);
  }
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    const matchStart = match.index;
    const matchEnd = match.index + match[0].length;
    if (lastIndex < matchStart) {
      tokens.push(react_1.default.createElement("span", {
        key: `token-${lastIndex}-${matchStart}`
      }, template.slice(lastIndex, matchStart)));
    }
    if (match[4]) {
      tokens.push(react_1.default.createElement("br", {
        key: `token-${matchStart}-${matchEnd}`
      }));
    } else {
      const emphasis = match[0].startsWith('*') ? 'color' : match[0].startsWith('_') ? 'bold' : 'normal';
      const compoundVariable = match[1] || match[2] || match[3];
      const [variable, textTransform] = compoundVariable.split('.');
      tokens.push(react_1.default.createElement("span", {
        key: `token-${matchStart}-${matchEnd}`,
        style: {
          fontWeight: emphasis === 'normal' ? 'normal' : 'bold',
          color: emphasis === 'color' ? props.emphasisColor : '',
          textTransform: textTransform || 'unset'
        }
      }, `${props[variable]}`));
    }
    lastIndex = matchEnd;
    if (i === matches.length - 1 && matchEnd !== template.length) {
      tokens.push(react_1.default.createElement("span", {
        key: i
      }, template.slice(matchEnd, template.length)));
    }
  }
  return tokens;
}
ParsedTemplate.propTypes = {
  template: prop_types_1.string.isRequired,
  label: prop_types_1.string,
  value: prop_types_1.string,
  yType: prop_types_1.string,
  rowLabel: prop_types_1.string,
  rowPercent: prop_types_1.string,
  totalPercent: prop_types_1.string
};
exports.default = ParsedTemplate;